import React from 'react'
import { useLanguage } from '#app/contexts/language-context.tsx'
import { cn } from '#app/utils/misc.tsx';
import { Icon } from './ui/icon';


interface CheckBoxGroupProps {
    value: string[],
    name: string,
    className?: string,
    items: any[],
    onChange: (field:string, value:string[]) => void
}

export default function CheckBoxGroup({value, name, className, items, onChange}:CheckBoxGroupProps) {
  const { currentLang } = useLanguage()

  function handleCheck(event:React.ChangeEvent<HTMLInputElement>) {
    const {target} = event ?? {};

    if (!target || target.type !== 'checkbox') return;

    if(target.checked) {
      const newSelection = value.concat([target.value]);
      onChange(name, newSelection);
    } else {
      const newSelection = value.filter(item => item != target.value);
      onChange(name, newSelection);
    }
  }

  return (
    <div className={cn("grid gap-2", className)}>
        { items.map(item => (
            <button key={item.id}>
                <input id={item.id} value={item.id} name={name} type="checkbox" defaultChecked={value.includes(item.id)} className="hidden" onChange={(e) => handleCheck(e)} />
                <label
                    className={`relative flex space-x-4 items-center justify-between h-10 px-4 py-2 border border-input rounded-lg bg-background ${value.includes(item.id) ? 'bg-primary text-primary-foreground' : 'hover:bg-accent hover:text-accent-foreground'}`}
                    htmlFor={item.id}
                    role='radio'
                >
                    <span className='text-sm font-medium leading-none'>{currentLang === 'en' ? item.label : item.labelGR}</span>
                    {value.includes(item.id) && (
                        <Icon name="check-circle" size="lg" role='status'/>
                    )}
                </label>
            </button>
        ))}
    </div>
  )
}